module.exports = __webpack_public_path__ + "img/banner-notice-text.3e5e1524.png";